import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    Grid,
    Paper,
    Typography,
    ButtonGroup,
    Button,
    FormControl,
    MenuItem,
    TextField,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';

import {
    setItemsPerPage, incrementZonePageIndex, decrementZonePageIndex,
    incrementMarkerPageIndex, decrementMarkerPageIndex,
    itemsPerPageSelector, zonePageIndexSelector, zonePageCountSelector,
    markerPageIndexSelector, markerPageCountSelector

} from '../../features/places/placesSlice';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 100,
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
}));

const perPageOptions = [10, 25, 50, 100];


const PacesBarPaginate = ({ listView }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const itemsPerPage = useSelector(itemsPerPageSelector);

    const zonePageIndex = useSelector(zonePageIndexSelector);
    const zonePageCount = useSelector(zonePageCountSelector);
    const markerPageIndex = useSelector(markerPageIndexSelector);
    const markerPageCount = useSelector(markerPageCountSelector);

    const [toShow, setToShow] = useState(true);

    const [perPage, setPerPage] = useState(25);
    const onPerPage = (e) => {
        //console.log("On page", e.target.value);
        setPerPage(e.target.value);
        dispatch(setItemsPerPage(e.target.value));
    }

    const onIncrement = () => {
        if (listView === 'zoneList') {
            dispatch(incrementZonePageIndex());
        } else {
            dispatch(incrementMarkerPageIndex());
        }
    }

    const onDecrement = () => {
        if (listView === 'zoneList') {
            dispatch(decrementZonePageIndex());
        } else {
            dispatch(decrementMarkerPageIndex());
        }
    }

    useEffect(() => {
        setPerPage(itemsPerPage);
    }, [itemsPerPage]);

    useEffect(() => {
        if (listView === 'zoneList') {
            if (zonePageCount < 1) {
                setToShow(false);
            }
        } else {
            if (markerPageCount < 1) {
                setToShow(false);
            }
        }
    }, [listView, zonePageCount, markerPageCount])

    if (toShow) {
        return (
            <div style={{ marginTop: '2px', marginBottom: '2px' }}>
                <Paper>
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        alignContent="center"
                        wrap='wrap'
                        spacing={1}
                        style={{
                            marginLeft: '5px',
                            marginBottom: '5px',
                        }}
                    >
                        <Grid item sm={7}>
                            <ButtonGroup size="small">
                                <Button
                                    startIcon={<FastRewindIcon color="primary" />}
                                    onClick={() => onDecrement()}
                                    disabled={listView === 'zoneList' ? zonePageIndex === 1 : markerPageIndex === 1}
                                />
                                <Button>
                                    {
                                        listView === 'zoneList' ?
                                            <Typography variant="body1" align="center">
                                                Page: {zonePageIndex}/{zonePageCount}
                                            </Typography>
                                            :
                                            <Typography variant="body1" align="center">
                                                Page: {markerPageIndex}/{markerPageCount}
                                            </Typography>
                                    }

                                </Button>
                                <Button
                                    endIcon={<FastForwardIcon color="primary" />}
                                    onClick={() => onIncrement()}
                                    disabled={listView === 'zoneList' ? zonePageIndex === zonePageCount : markerPageIndex === markerPageCount}
                                />
                            </ButtonGroup>
                        </Grid>

                        <Grid item sm={5}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id="peiodTypeSelect"
                                    select
                                    value={perPage}
                                    onChange={onPerPage}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">Per Page:</InputAdornment>,
                                    }}
                                >
                                    {
                                        perPageOptions.map(ev => <MenuItem key={ev} value={ev}>{ev}</MenuItem>)
                                    }
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        );
    } else {
        return null;
    }


}

export default PacesBarPaginate;